import { useOverlay } from '@abyss/web/hooks/useOverlay';
import { ModalState, useModalStore } from '@src/store/common/ModalStore';

const ModalService = () => {
  const modalOverlay = useOverlay('crdp-modal');

  const displayModal = useModalStore((state) => state.displayModal);
  const modalState = useModalStore((state) => state.modalState);

  const hideModal = async (key?: string) => {
    if (!key || modalState.key === key) {
      modalOverlay.close();
    }
  };

  const showModal = async (state: ModalState) => {
    await displayModal({
      ...modalState,
      key: state.key || 'default',
      title: state.title,
      message: state.message,
      cancelText: state.cancelText === null ? 'Cancel' : state.cancelText,
      submitText: state.submitText === null ? 'Confirm' : state.submitText,
      handleConfirm: state.handleConfirm,
      handleCancel: state.handleCancel,
    });
    modalOverlay.open();
  };

  return { modalState, showModal, hideModal };
};

export { ModalService };
